import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player";
import { Jimage } from "react-jimp";

const OneCardPreview = ({ type, url }) => {
  const [textFile, setTextFile] = useState("");
  useEffect(async () => {
    if (type === "text") {
      if (url) {
        const res = await fetch(url);
        const result = await res.text();

        if (!result.startsWith("�PNG")) {
          setTextFile(result);
        }
      }
    }
  }, [type, url]);
  return (
    <div
      className="w-full"
      onContextMenu={(e) => {
        e.preventDefault();
      }}
    >
      {url ? (
        type === "image" ? (
          <Jimage src={url} />
        ) : type === "video" ? (
          <ReactPlayer width="100%" height="100%" url={url} />
        ) : type === "text" ? (
          // <div
          //   className="w-full h-full p-2"
          //   dangerouslySetInnerHTML={{
          //     __html: `<iframe src="${url}}"  width="100%" height="100%"/>`,
          //   }}
          // />
          textFile && textFile !== "" ? (
            <div className="w-full overflow-y-auto max-h-96">
              <div className="w-full h-full text-xs p-1 bg-white">{textFile ? textFile : ""}</div>
            </div>
          ) : (
            ""
          )
        ) : (
          <img src="/images/market/no-img.png" />
        )
      ) : (
        <img src="/images/market/no-img.png" />
      )}
    </div>
  );
};

export default OneCardPreview;
